// Texts are stored in the VO/API at the same endpoint
// Use this mixin to grab text by key
export default {
  name: "homepageTexts",
  methods: {
    getTexts: function(data, key) {
      axios({ method: "GET", "url": `${process.env.VUE_APP_API_ENDPOINT}/texts/home` }).then(result => {
        this[data] = result.data.en[key];
      }, error => {
        console.error(error);
      });
    }
  },
};
